// extracted by mini-css-extract-plugin
module.exports = {"container":"c01c","img":"_865c"};